function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "42.5",
  cy: "43.5",
  r: "10.5",
  transform: "rotate(-89.92 42.5 43.5)",
  fill: "#f1635e"
}), /*#__PURE__*/React.createElement("rect", {
  x: "7",
  y: "8",
  width: "21",
  height: "21",
  rx: "2",
  ry: "2",
  fill: "#95ca4b"
}), /*#__PURE__*/React.createElement("rect", {
  x: "32",
  y: "8",
  width: "21",
  height: "21",
  rx: "2",
  ry: "2",
  fill: "#38c1d2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "7",
  y: "33",
  width: "21",
  height: "21",
  rx: "2",
  ry: "2",
  fill: "#f49e52"
}));